"use client"
import { usePathname } from "next/navigation"

const HIDE_FOOTER_PATHS = ["/thirdMd", "/third-callback"] // 需要隐藏 Footer 的路径

export function FooterWrapper({ children }: { children: React.ReactNode }) {
	const pathname = usePathname()
	// 你如果是多语言路由，可能需要处理 locale 前缀
	const path = pathname.replace(/^\/[a-zA-Z-]+/, "")
	if (HIDE_FOOTER_PATHS.some((p) => path.startsWith(p))) {
		return null
	}
	return <>{children}</>
}
